"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ImagingStudy = exports.ImagingStudyStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_ImagingStudy_Series_1 = require("./RTTI_ImagingStudy_Series");
var ImagingStudyStatusKind;
(function (ImagingStudyStatusKind) {
    ImagingStudyStatusKind["_registered"] = "registered";
    ImagingStudyStatusKind["_available"] = "available";
    ImagingStudyStatusKind["_cancelled"] = "cancelled";
    ImagingStudyStatusKind["_enteredInError"] = "entered-in-error";
    ImagingStudyStatusKind["_unknown"] = "unknown";
})(ImagingStudyStatusKind = exports.ImagingStudyStatusKind || (exports.ImagingStudyStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ImagingStudy = t.recursion('IImagingStudy', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('ImagingStudy'),
            subject: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: (0, EnumType_1.createEnumType)(ImagingStudyStatusKind, 'ImagingStudyStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            modality: t.array(RTTI_Coding_1.RTTI_Coding),
            encounter: RTTI_Reference_1.RTTI_Reference,
            started: RTTI_dateTime_1.RTTI_dateTime,
            _started: RTTI_Element_1.RTTI_Element,
            basedOn: t.array(RTTI_Reference_1.RTTI_Reference),
            referrer: RTTI_Reference_1.RTTI_Reference,
            interpreter: t.array(RTTI_Reference_1.RTTI_Reference),
            endpoint: t.array(RTTI_Reference_1.RTTI_Reference),
            numberOfSeries: RTTI_unsignedInt_1.RTTI_unsignedInt,
            _numberOfSeries: RTTI_Element_1.RTTI_Element,
            numberOfInstances: RTTI_unsignedInt_1.RTTI_unsignedInt,
            _numberOfInstances: RTTI_Element_1.RTTI_Element,
            procedureReference: RTTI_Reference_1.RTTI_Reference,
            procedureCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            location: RTTI_Reference_1.RTTI_Reference,
            reasonCode: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            reasonReference: t.array(RTTI_Reference_1.RTTI_Reference),
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            description: t.string,
            _description: RTTI_Element_1.RTTI_Element,
            series: t.array(RTTI_ImagingStudy_Series_1.RTTI_ImagingStudy_Series)
        })
    ]);
});
//# sourceMappingURL=RTTI_ImagingStudy.js.map